import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Components
import Modal from '../../Modal';
import MobileMenu from '../../MobileMenu';
import CitySelector from '../../CitySelector';
import Logo from '../../Logo';

// Router
import { paths, getRoute } from '../../../entry/routes';

// Styles
import styles from './Header.styl';
import ModalCityRedirect from '../../ModalCityRedirect/MobileView/ModalCityRedirect';
import ModalRestaurant from '../partials/ModalRestaurant/MobileView';

const cx = classNames.bind(styles);

export default function MobileView(props) {
  const { className } = props;

  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(prev => !prev);
  };

  return (
    <header className={cx('Header', className)}>
      <Link to={getRoute(paths.home)} className={cx('Header__logo')}>
        <Logo />
      </Link>
      <CitySelector />
      <ModalRestaurant />
      <div
        className={cx('Header__hamburger')}
        onClick={toggle}
        onKeyDown={e => e.key === 'Enter' && toggle()}
        role="button"
        tabIndex={0}
      >
        <div className={cx('Header__hamburger-line')} />
        <div className={cx('Header__hamburger-line')} />
        <div className={cx('Header__hamburger-line')} />
      </div>
      <ModalCityRedirect />

      <Modal isOpen={isOpen} onClose={toggle} direction="left" exit={0}>
        <MobileMenu onClose={toggle} />
      </Modal>
    </header>
  );
}

MobileView.defaultProps = {
  className: '',
};

MobileView.propTypes = {
  className: PropTypes.string,
};
